/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '@irian-ro/util-environment';
import { AbstractFileStorageService } from '@well/file-storage';

@Injectable({ providedIn: 'root' })
export class DeliveryFileStorageService extends AbstractFileStorageService {
  protected apiEndPoint: string;

  constructor(
    protected http: HttpClient,
    environmentService: EnvironmentService
  ) {
    super();
    this.apiEndPoint = environmentService.getEnvironmentProperty('deliveryFileStorageUrl');
  }
}
